import { createAction, Dispatch } from '@reduxjs/toolkit';
import { EsmeModel } from '../../models/esmeModel';
import EsmeApi from '../../api/esmeApi';
import { AppError } from '../../types/appError';

export const esmeFetchAllRequestAction = createAction<void>('esme/fetchAllRequest');
export const esmeFetchAllSuccessAction = createAction<EsmeModel[]>('esme/fetchAllSuccess');
export const esmeFetchAllFailureAction = createAction<AppError>('esme/fetchAllFailure');

export const fetchAllEsmeByCommitId = (commitId: string) => async (dispatch: Dispatch) => {
  dispatch(esmeFetchAllRequestAction());
  try {
    const allEsme = await EsmeApi.fetchAllEsmeByCommitId(commitId);
    dispatch(esmeFetchAllSuccessAction(allEsme));
  } catch (error) {
    dispatch(esmeFetchAllFailureAction(error as AppError));
  }
}
